/**
 * PixelBlock Python Integration Suite.
 */
import PIXELBLOCK_COLORS from './colors';
import { registerPixelBlockBlocks } from './blocks';
import { workspaceToPython, blockToPythonStmt, blockToPythonExpr } from './generator';
import { pythonToWorkspace } from './parser';
import { runPython } from './runner';
import downloadBlob from '../download-blob';
import {
    PIXELBLOCK_MESSAGES,
    getPixelBlockLocale,
    getPixelBlockMsg,
    getArithmeticOptions,
    getCompareOptions,
    getBoolOpOptions,
    getBooleanOptions,
    getVarChangeOptions,
    registerPixelBlockLocales
} from './messages';

export {
    PIXELBLOCK_COLORS,
    registerPixelBlockBlocks,
    workspaceToPython,
    blockToPythonStmt,
    blockToPythonExpr,
    pythonToWorkspace,
    runPython,
    PIXELBLOCK_MESSAGES,
    getPixelBlockLocale,
    getPixelBlockMsg,
    getArithmeticOptions,
    getCompareOptions,
    getBoolOpOptions,
    getBooleanOptions,
    getVarChangeOptions,
    registerPixelBlockLocales
};

export function exportPythonFile(workspace, filename = 'pixelblock_project.py') {
    if (!filename.endsWith('.py')) {
        filename += '.py';
    }
    const code = workspaceToPython(workspace);
    const blob = new Blob([code], { type: 'text/x-python;charset=utf-8' });
    downloadBlob(filename, blob);
    return code;
}

export function importPythonFile(file, workspace) {
    return new Promise((resolve, reject) => {
        if (!file) {
            reject(new Error('No file provided'));
            return;
        }
        const reader = new FileReader();
        reader.onload = event => {
            const content = event.target.result;
            try {
                const success = pythonToWorkspace(content, workspace);
                resolve({ success, content, filename: file.name });
            } catch (err) {
                reject(err);
            }
        };
        reader.onerror = err => reject(err);
        reader.readAsText(file);
    });
}
